import useReveal from "../hooks/useReveal";

export default function HowItWorks() {
    // hook returns a ref + "visible" class when element is in view
    const [ref, visible] = useReveal({ threshold: 0.18, rootMargin: "-40px" });
  return (
    <section id="how-it-works" className="relative py-16 howitworks overflow-hidden">

      <div 
      ref={ref}
          className={`container max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-start ${
            visible ? "animate-fade-up" : "opacity-0 translate-y-6"
          }`}>

        {/* LEFT CONTENT */}
        <div>
          <span className="text-sm font-semibold tracking-widest --secondary uppercase">
            How it works
          </span>

          <h2 className="mt-3 text-4xl font-extrabold text-white leading-tight">
            Simple loan workflow <br /> from start to finish
          </h2>

          {/* LEFT STEPS */}
          <div className="mt-12 space-y-10 relative">
            <TimelineStep
              number="01"
              title="Add a Customer"
              desc="Enter name, number, and loan type in seconds."
            />
            <TimelineStep
              number="02"
              title="Share the Checklist"
              desc="Tap once → WhatsApp opens → Ready-to-send professional template."
            />
            <TimelineStep
              number="03"
              title="Track Progress"
              desc="Update loan stages as you move forward."
            />
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="relative w-full max-w-[360px]">
          {/* Illustration container */}
          <div className="relative bg-purple-50 rounded-3xl p-10 shadow-lg mb-14">
            <img src="/screens/howitworks.png" alt="" />
          </div>

          {/* RIGHT STEPS 
          <div className="space-y-10">
            <TimelineStep
              number="04"
              title="Track loan stages"
              desc="Monitor every case with clear loan-stage progress."
            />
            <TimelineStep
              number="05"
              title="Close faster"
              desc="Reduce follow-ups and close loans with confidence."
            />
          </div> */}
        </div>

      </div>
    </section>
  );
}

/* STEP COMPONENT */
function TimelineStep({ number, title, desc }) {
  return (
    <div className="flex gap-6 items-start">
      <div className="flex flex-col items-center">
        <div className="w-10 h-10 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center font-bold">
          {number}
        </div>
        <div className="flex-1 w-px bg-purple-200 mt-2" />
      </div>

      <div>
        <h4 className="text-lg font-semibold secondary">
          {title}
        </h4>
        <p className="mt-1 lp-muted max-w-md">
          {desc}
        </p>
      </div>
    </div>
  );
}
